/* =========================================================
* 個別にチェックした時のidsの更新を抽象化した関数
* @params ids ids系の状態（eg. areaIds）
* @params setIds setIds系のイベントハンドラ（eg. setAreaIds）
========================================================= */
export const handleChangeIds = (ids, setIds) => (e) => {
  let newIds = ids.slice();
  const targetId = e.target.value;
  if (newIds.includes(targetId)) {
    newIds = newIds.filter(v => v !== targetId)
  } else {
    newIds = [...newIds, targetId]
  }
  setIds(newIds)
}

/* =========================================================
* 一括チェックによるidsの更新を抽象化した関数
* @param allChecked 全てチェックされているか
* @param allCheckIds 一括チェック対象のidの配列
* @param ids ids系の状態（eg. areaIds）
* @param setIds setIds系のイベントハンドラ（eg. setAreaIds）
========================================================= */
export const handleCheckAll = (allChecked, allCheckIds, ids, setIds) => {
  if (allChecked) {
    uncheckAllCheckbox(allCheckIds, ids, setIds);
  } else {
    checkAllCheckbox(allCheckIds, ids, setIds);
  }
}

/* =========================================================
* チェックボックスごとのaggsを取得する関数
========================================================= */
export const countHits = (aggs, itemVal) => {
  const targetAgg = aggs.find(agg => agg.key == itemVal);
  const count = !targetAgg ? 0 : targetAgg.doc_count;
  return count;
};

const checkAllCheckbox = (allCheckIds, ids, setIds) => {
  const combinedIds = [...ids, ...allCheckIds];
  const uniqueIds = combinedIds.filter((id, index) => combinedIds.indexOf(id) === index);
  setIds(uniqueIds);
}


export const uncheckAllCheckbox = (allCheckIds, ids, setIds) => {
  let newIds = ids.slice();
  for (let i=0; i < allCheckIds.length; i++) {
    newIds = newIds.filter((n) => n !== allCheckIds[i])
  }
  setIds(newIds);
}
